class loadingButton extends HTMLElement {
  constructor() {
    super();
    this.url = '';
    this.loadButton = this.querySelector('button');
    this.productContainer = document.querySelector('#main-grid');
    this.vanillaPagination = document.querySelector('#pagination');
    this.productCounter = document.querySelector('.product-counter');
    this.visualWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    if (this.loadButton) {
      this.loadButton.addEventListener('click', this.loadMore.bind(this));
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.syncButtonState();
    }, 50);
  }

  syncButtonState() {
    if (!this.loadButton) return;
    
    const nextLink = document.querySelector('.pagination__list li:last-child a.pagination__item-arrow') || 
                     document.querySelector('.pagination-wrapper a.next-item');

    if (nextLink && nextLink.href) {
      this.loadButton.setAttribute('data-next-url', nextLink.href);
      this.loadButton.innerHTML = '<span>LOAD NEXT PAGE</span>';
      this.loadButton.disabled = false;
    } else {
      this.setLastPageLoaded();
    }
  }

  getNextUrl() {
    if (this.loadButton.hasAttribute('data-next-url')) {
      return this.loadButton.getAttribute('data-next-url');
    }
    const nextLink = document.querySelector('.pagination__list li:last-child a.pagination__item-arrow') || 
                     document.querySelector('.pagination-wrapper a.next-item');
    return nextLink ? nextLink.href : null;
  }

  loadMore(event) {
    event.preventDefault();
    this.url = this.getNextUrl();

    if (!this.url || this.loadButton.disabled) {
      this.setLastPageLoaded();
      return;
    }

    this.loadButton.classList.add('loading');
    /* Clean text change without any loading spinner wheel */
    this.loadButton.innerHTML = '<span>LOADING...</span>';
    this.fetchItems(this.url, event);
  }

  fetchItems(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProductGrid(html);
        this.renderNewNavigation(html);
        this.renderProductCounter(html);
        this.loadingButtonChecker(html, event);
        window.history.pushState({}, '', url);
      })
      .catch((error) => {
        console.error('Error fetching pagination:', error);
        this.loadButton.classList.remove('loading');
        this.loadButton.innerHTML = '<span>LOAD NEXT PAGE</span>';
      });
  }

  renderProductGrid(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const mainGrid = doc.getElementById('main-grid');
    if (!mainGrid) return;

    let newPage = mainGrid.innerHTML;
    if (document.querySelector("masonry-grid")) {
      this.masonryGrid(newPage);
    } else {
      this.productContainer.innerHTML = this.productContainer.innerHTML + newPage;
    }
  }

  renderNewNavigation(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newPagination = doc.getElementById('pagination');
    if (this.vanillaPagination && newPagination) {
      this.vanillaPagination.innerHTML = newPagination.innerHTML;
    }
  }

  renderProductCounter(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newCounter = doc.querySelector('.product-counter');
    if (this.productCounter && newCounter) {
      this.productCounter.innerHTML = newCounter.innerHTML;
    }
  }

  masonryGrid(newPage) {
    if (this.visualWidth > 780 && window.Masonry && window.msnry) {
      document.getElementById('main-grid').removeAttribute('style');
      document.querySelectorAll('.grid__item').forEach((item) => {
        item.removeAttribute('style');
      });
      window.msnry.destroy();
      setTimeout(() => {
        let grid = document.querySelector('.masonry');
        let msnry = new Masonry(grid, {
          itemSelector: '.masonry-item',
          columnWidth: '.grid-sizer',
          percentPosition: true
        });
        window.msnry = msnry;
      }, 10);
    }

    let newPageClean = newPage.replace('<div class="grid-sizer"></div>', '');
    this.productContainer.innerHTML = this.productContainer.innerHTML + newPageClean;
  }

  loadingButtonChecker(html, event) {
    this.loadButton.classList.remove('loading');
    
    const doc = new DOMParser().parseFromString(html, 'text/html');
    
    const newNextLink = doc.querySelector('.pagination__list li:last-child a.pagination__item-arrow') || 
                        doc.querySelector('.pagination-wrapper a.next-item');

    if (newNextLink && newNextLink.href) {
      this.loadButton.setAttribute('data-next-url', newNextLink.href);
      this.loadButton.innerHTML = '<span>LOAD NEXT PAGE</span>';
      this.loadButton.disabled = false;
    } else {
      this.setLastPageLoaded();
    }
  }

  setLastPageLoaded() {
    this.loadButton.classList.remove('loading');
    this.loadButton.innerHTML = '<span>LAST PAGE HAS LOADED</span>';
    this.loadButton.disabled = true;
    this.loadButton.removeAttribute('data-next-url');
  }
}

if (!customElements.get('loading-button')) {
  customElements.define('loading-button', loadingButton);
}